import axios, { type AxiosInstance } from 'axios'
import { ASSETS_API_BASE_URL, STOCK_PRICES_API_BASE_URL } from './endpoints'
import { setupAuthInterceptor } from '@/lib/authInterceptor'

function createAuthAxios(baseURL: string): AxiosInstance {
  const instance = axios.create({ baseURL, timeout: 15000, headers: { 'Content-Type': 'application/json' } })
  setupAuthInterceptor(instance)
  return instance
}

export const assetsAxios = createAuthAxios(ASSETS_API_BASE_URL)
export const stockPricesAxios = createAuthAxios(STOCK_PRICES_API_BASE_URL)
